import { render, staticRenderFns } from "./BaseMarkdown.vue?vue&type=template&id=962b1dc4&scoped=true"
import script from "./BaseMarkdown.vue?vue&type=script&lang=js"
export * from "./BaseMarkdown.vue?vue&type=script&lang=js"
import style0 from "./BaseMarkdown.vue?vue&type=style&index=0&id=962b1dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962b1dc4",
  null
  
)

export default component.exports